/** What the latest review scan could not check, per thread, in plain words
 *  (AIVA-9191). The scan sets it; the review panel shows it, so a clean
 *  result is never read as "everything was checked". */

const EMPTY: readonly string[] = [];
const notesByThread = new Map<string, readonly string[]>();
const listeners = new Set<() => void>();

/** Replaces the thread's notes — each scan's notes stand alone. */
export function setScanNotes(threadId: string, notes: readonly string[]): void {
  notesByThread.set(threadId, notes.length > 0 ? notes : EMPTY);
  listeners.forEach((listener) => listener());
}

export function getScanNotes(threadId: string | null): readonly string[] {
  return (threadId && notesByThread.get(threadId)) || EMPTY;
}

export function subscribeScanNotes(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
